import { render, staticRenderFns } from "./DirectSettlementDetail.vue?vue&type=template&id=8483569c"
import script from "./DirectSettlementDetail.vue?vue&type=script&lang=js"
export * from "./DirectSettlementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports